<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Settlement"
              bc1="App"
              bc2="Aggregate"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- users list start -->
        <section class="app-user-list">
          <div class="card">
            <h5 class="card-header">Filters</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Select Store</label>
                      <SearchSelect
                          v-model="selectedStore"
                          url="v1/get-store"
                          :filterParams="{ status: 1 }"
                          :customLabelFn="customStoreNameForMultiselect"
                          placeholder="Search Store..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Terminal</label>
                      <multiselect
                          v-model="selectedTerminal"
                          :options="terminalData"
                          label="label"
                          track-by="id"
                          placeholder="Select Terminal"
                          :loading="terminalLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Channel</label>
                      <multiselect
                          v-model="selectedChannel"
                          :options="channelData"
                          label="label"
                          track-by="id"
                          placeholder="Select Channel"
                          :loading="channelLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_status col-sm-12">
                <input class="form-control mt-sm-50" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
              </div>
              <div class="col-md-6 user_plan mt-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                      <date-picker
                          v-model="fromDate"
                          :disabledDate="disableFutureDates"
                          valueType="format"
                          :lang="lang"
                          name="fromDate"
                          placeholder="choose start date"
                      ></date-picker>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mt-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                      <date-picker
                          v-model="toDate"
                          :disabledDate="disableFutureDates"
                          valueType="format"
                          :lang="lang"
                          name="toDate"
                          placeholder="choose end date"
                      ></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_status">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
              </div>

            </div>
          </div>
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'create-aggregator-settlements' })"
                    >
                      <span class="text-nowrap">Create Settlement</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ul class="nav nav-tabs m-1" role="tablist">
                <li class="nav-item"  @click="tabToShow = 1">
                  <a class="nav-link" :class="tabToShow == 1 ? 'active' : ''" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Initiated</a>
                </li>
                <li class="nav-item" @click="tabToShow = 4">
                  <a class="nav-link" :class="tabToShow == 4 ? 'active' : ''" id="transmit-tab" data-toggle="tab" href="#transmit" aria-controls="profile" role="tab" aria-selected="false">In Transit</a>
                </li>
                <li class="nav-item" @click="tabToShow = 2">
                  <a class="nav-link" :class="tabToShow == 2 ? 'active' : ''" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="false">Canceled</a>
                </li>
                <li class="nav-item" @click="tabToShow = 3">
                  <a class="nav-link" :class="tabToShow == 3 ? 'active' : ''" id="failure-tab" data-toggle="tab" href="#failure" aria-controls="profile" role="tab" aria-selected="false">Completed</a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane " :class="tabToShow == 1 ? 'active' : ''" id="home" aria-labelledby="home-tab" role="tabpanel">
                  <InitiatedSettlement v-if="tabToShow == 1" @changeTab="triggerChangeTab" :filter="filteredDataInitiated" />
                </div>
                <div class="tab-pane" :class="tabToShow == 2 ? 'active' : ''" id="profile" aria-labelledby="profile-tab" role="tabpanel">
                  <CancelledSettlement v-if="tabToShow == 2" :filter="filteredDataCanceled" />
                </div>
                <div class="tab-pane" :class="tabToShow == 3 ? 'active' : ''" id="failure" aria-labelledby="failure-tab" role="tabpanel">
                  <CompletedSettlement v-if="tabToShow == 3" :filter="filteredDataCompleted" />
                </div>
                <div class="tab-pane" :class="tabToShow == 4 ? 'active' : ''" id="transmit" aria-labelledby="failure-tab" role="tabpanel">
                  <TransmittedProgressWrapper v-if="tabToShow == 4" @changeTab="triggerChangeTab" :filter="filteredDataTransmitted" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- users list ends -->

      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import InitiatedSettlement from '@/pages/dashboard/settlements/aggregate/tabs/main-listing/InitiatedSettlement'
import CompletedSettlement from '@/pages/dashboard/settlements/aggregate/tabs/main-listing/CompletedSettlement'
import CancelledSettlement from '@/pages/dashboard/settlements/aggregate/tabs/main-listing/CancelledSettlement'
import SearchSelect from "@/components/common/SearchSelect.vue";
import TransmittedSettlement from "@/pages/dashboard/settlements/aggregate/tabs/main-listing/TransmittedSettlement.vue";
import ProgressSettlement from "@/pages/dashboard/settlements/aggregate/tabs/main-listing/ProgressSettlement.vue";
import TransmittedProgressWrapper from "@/pages/dashboard/settlements/aggregate/tabs/TransmittedProgressWrapper.vue";
export default {
  props: ['propFilters'],
  components:{
    DatePicker,
    TransmittedProgressWrapper,
    ProgressSettlement,
    TransmittedSettlement,
    SearchSelect,
    InitiatedSettlement,
    CompletedSettlement,
    CancelledSettlement

  },
  mounted() {
    var tabShow = 1
    if(typeof(this.$route.query.tab) != 'undefined'){
      tabShow = this.$route.query.tab
    }
    else{
      tabShow = 1
    }
    // this.getStoreData()

    if(typeof(this.propFilters) != 'undefined'){

      let filterData = {}


      if(this.propFilters.selectedStore){
        this.selectedStore = this.propFilters.selectedStore
        filterData.storeId = this.selectedStore.id
      }

      if(this.propFilters.selectedTerminal){
        this.selectedTerminal = this.propFilters.selectedTerminal
        filterData.terminalId = this.selectedTerminal.id
      }

      if(this.propFilters.selectedChannel){
        this.selectedChannel = this.propFilters.selectedChannel
        filterData.channelId = this.selectedChannel.id
      }

      if(this.propFilters.tabToShow){
        tabShow = this.propFilters.tabToShow
      }



      if(tabShow == 1){
        filterData.tabToShow = 1
        this.filteredDataInitiated = filterData

      }else if(tabShow == 2){
        filterData.tabToShow = 2
        this.filteredDataCanceled = filterData
      }else if(tabShow == 3){
        filterData.tabToShow = 3
        this.filteredDataCompleted = filterData
      }


    }

    this.tabToShow = tabShow

    setTimeout(()=>{
      this.onSubmitFilters()
    },1000)

  },
  data() {
    return {
      fromDate: null,
      toDate: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      tabToShow: 0,
      tab2sendCall: false,
      tab3sendCall: false,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      filteredDataInitiated: {},
      filteredDataCanceled: {},
      filteredDataCompleted: {},
      filteredDataTransmitted: {},
      filteredDataInProgress: {},
      search: '',

    }
  },
  methods: {
    triggerChangeTab(val){
      this.tabToShow = val
    },
    onSubmitFilters() {

      let filterData = {}

      if(this.selectedStore){
        filterData.selectedStore = this.selectedStore
        filterData.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        filterData.selectedTerminal = this.selectedTerminal
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.selectedChannel = this.selectedChannel
        filterData.channelId = this.selectedChannel.id
      }

      if(this.search != ''){
        filterData.search = this.search
      }

      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }

      if(this.tabToShow == 1){
        filterData.tabToShow = 1
        this.filteredDataInitiated = filterData
      }else if(this.tabToShow == 2){
        filterData.tabToShow = 2
        this.filteredDataCanceled = filterData
      }else if(this.tabToShow == 3){
        filterData.tabToShow = 3
        this.filteredDataCompleted = filterData
      }else if(this.tabToShow == 4){
        filterData.tabToShow = 4
        this.filteredDataTransmitted = filterData
      }else if (this.tabToShow == 5){
        filterData.tabToShow = 5
        this.filteredDataInProgress = filterData
      }


    },
    clear(){
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.search = ''
      this.toDate = null
      this.fromDate = null
      this.filteredDataInitiated = {}
      this.filteredDataCanceled = {}
      this.filteredDataCompleted = {}
      this.filteredDataTransmitted = {}
      this.filteredDataInProgress = {}




    },
    getStoreData() {
      this.makeRequest("post", "v1/get-store", {status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.storeData = responseData;
                }
                else{
                  this.storeData = []
                }
                // this.setSelectedStoreValue();
              }
            }
          }
      );
    },
    setSelectedStoreValue() {


      if (this.selectedStore == null && this.storeData.length > 0) {
        this.selectedStore = this.storeData[0];

      }
      else{
        this.selectedStore = null
      }
    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
  },
  watch: {
    tabToShow(val) {
      // this.clear()
      // send call for second and third tabs if tab is clicked, send call if not sent before
      if(val == 2 && !this.tab2sendCall )
        this.tab2sendCall = true;
      else if(val == 3 && !this.tab3sendCall )
        this.tab3sendCall = true;
    },
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

